module.exports = __webpack_public_path__ + "img/20190802132108824.70d4f139.png";